import React from 'react';
import Templates from '../components/Templates';

const TemplatesPage = () => {
  return <Templates />;
};

export default TemplatesPage;
